import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import EmailListEditor from "@/components/EmailListEditor";

export default function SiteRoleCard({ row, isNationalAdmin, onUpdateField, onDelete }) {
  return (
    <div className="bg-card border border-border rounded-lg p-4 space-y-4" data-testid={`site-card-${row.key}`}>
      <div className="flex items-center justify-between">
        <div>
          <p className="font-heading font-semibold text-foreground" data-testid={`site-name-${row.key}`}>
            {row.site}
          </p>
          {row.service && <p className="text-xs text-muted-foreground">{row.service}</p>}
        </div>
        {isNationalAdmin && (
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onDelete(row.key)}
            data-testid={`delete-site-button-${row.key}`}
            title="Supprimer ce site"
          >
            <Trash2 className="h-4 w-4 text-destructive" />
          </Button>
        )}
      </div>

      <div>
        <p className="text-xs uppercase tracking-wide text-muted-foreground mb-1.5">Administrateurs Site</p>
        <EmailListEditor
          emails={row.site_admins}
          disabled={!isNationalAdmin}
          onChange={(emails) => onUpdateField(row.key, "site_admins", emails)}
          testIdPrefix={`site-admins-${row.key}`}
        />
      </div>
      <div>
        <p className="text-xs uppercase tracking-wide text-muted-foreground mb-1.5">Créateurs SOP</p>
        <EmailListEditor
          emails={row.creators}
          onChange={(emails) => onUpdateField(row.key, "creators", emails)}
          testIdPrefix={`creators-${row.key}`}
        />
      </div>
      <div>
        <p className="text-xs uppercase tracking-wide text-muted-foreground mb-1.5">Valideurs SOP</p>
        <EmailListEditor
          emails={row.validators}
          onChange={(emails) => onUpdateField(row.key, "validators", emails)}
          testIdPrefix={`validators-${row.key}`}
        />
      </div>
      <div>
        <p className="text-xs uppercase tracking-wide text-muted-foreground mb-1.5">Utilisateurs SOP</p>
        <EmailListEditor
          emails={row.viewers}
          onChange={(emails) => onUpdateField(row.key, "viewers", emails)}
          testIdPrefix={`viewers-${row.key}`}
        />
      </div>
    </div>
  );
}
